import React from "react";
import { Link } from "react-router-dom";
import usesFeatures from "usesFeatures";
import { formatDate } from "date_helpers";
import formatCurrency from "utils/formatCurrency";

import Card from "Card";
import Header from "Header";
import DisplayField from "DisplayField";

// Read-only payout detail for venue admins. Shows the payout summary plus only
// the events from this venue (sibling-venue sales totals are never loaded).
class PayoutView extends React.Component {
  componentDidMount() {
    // Venue admin routes pass the matched params as `computedMatch` (Switch's
    // internal prop), not `match`.
    this.props.fetchData(`venue_admin/payouts/${this.props.computedMatch.params.id}`);
  }

  render() {
    if (!this.props.dataFetched) return false;

    const { payout, events } = this.props;

    return (
      <div className="PayoutView">
        <Header
          text={`Payout for ${payout.accountName} - ${payout.dateRange}`}
          backLink="/payouts"
        />

        <div className="columns">
          <div className="column">
            <h3 className="title">Payout Details</h3>
            <DisplayField label="Payout Total" value={payout.amount} />
            <DisplayField label="Dates" value={payout.dateRange} />
            <DisplayField label="Created" value={formatDate(payout.createdAt)} />
            <DisplayField
              label="Sent On"
              value={payout.sentOn ? formatDate(payout.sentOn) : "Not Sent"}
            />

            <h4 className="subtitle mt-4">Your Events in this Payout</h4>
            {(events || []).map((event) => (
              <Card title={event.name} key={event.id}>
                <div className="columns">
                  <div className="column">
                    <DisplayField label="Event Date" value={event.date} />
                  </div>
                  <div className="column">
                    <DisplayField
                      label="Payout Amount"
                      value={formatCurrency(event.totals.payoutTotal)}
                    />
                  </div>
                </div>
                <div className="buttons">
                  <Link className="button is-small" to={`/reports/${event.id}`}>
                    Sales Report
                  </Link>
                  <Link className="button is-small" to={`/reports/payments/${event.id}`}>
                    Payments Report
                  </Link>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default usesFeatures(["data"], PayoutView);
